import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/functions";

import { resolveFirebaseConfig } from "./firebaseConfig";

const firebaseConfig = resolveFirebaseConfig();

// ✅ Initialize Firebase App (avoid multiple default apps)
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// ✅ Export Firebase services
const auth = firebase.auth();
const db = firebase.firestore();
const storage = firebase.storage();

const functions = firebase.app().functions("us-central1");

// ✅ Persistence (compat): run once at module load
auth
  .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
  .catch((e) => console.warn("setPersistence failed:", e));

// (nice-to-have) use device language for auth flows
auth.useDeviceLanguage?.();

// ✅ Export Auth Providers
const googleProvider = new firebase.auth.GoogleAuthProvider();
googleProvider.setCustomParameters?.({ prompt: "select_account" });

const facebookProvider = new firebase.auth.FacebookAuthProvider();

// ✅ Optional: Expose firebase globally for reCAPTCHA
if (typeof window !== "undefined") {
  window.firebase = firebase;
  window.auth = auth;
  window.functions = functions;

  window.db = db;
  window.storage = storage;
}

export {
  firebase,
  auth,
  db,
  storage,
  functions,
  googleProvider,
  facebookProvider,
};
